import styles from '../table.module.scss';
import skeletonStyles from './TableSkeleton.module.scss';
import { TableHead } from '../constants';
import cn from 'classnames';

const GRID = { gridTemplateColumns: '23% 15% 12% 12% auto' };
const SKELETON_ROWS = Array.from({ length: 6 });

const TableSkeleton = () => (
  <div className={cn(styles.table)}>
    <div className={cn(styles.header, 'fs-12 pt-2')} style={GRID}>
      {TableHead.map(col => (
        <div key={col.key} className={cn(styles.unselected_filter, 'px-1')}>
          {col.name}
        </div>
      ))}
    </div>
    {SKELETON_ROWS.map((_, i) => (
      <div key={i} className={skeletonStyles.skeletonRow} style={GRID}>
        <div className={skeletonStyles.skeletonCell} />
        <div className={skeletonStyles.skeletonCell} />
        <div className={skeletonStyles.skeletonCell} />
        <div className={skeletonStyles.skeletonCell} />
        <div className={skeletonStyles.skeletonActionCell} />
      </div>
    ))}
  </div>
);

export default TableSkeleton;
